import { render, staticRenderFns } from "./RespostaProposta.vue?vue&type=template&id=19e93f66&"
import script from "./RespostaProposta.vue?vue&type=script&lang=js&"
export * from "./RespostaProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports